<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="fb-question">
        <span class="fb-bar fb-bar--md"></span>
      </div>
      <div class="fb-sentence">
        <span class="fb-word">The</span>
        <span class="fb-word">capital</span>
        <span class="fb-word">of</span>
        <span class="fb-blank --active">
          <span class="fb-blank-text">Portugal</span>
        </span>
        <span class="fb-word">is</span>
        <span class="fb-blank">
          <span class="fb-blank-text">Lisbon</span>
        </span>
        <span class="fb-word">.</span>
      </div>
      <div class="fb-meta">
        <span class="fb-dot"></span>
        <span class="fb-meta-label">Blank 1 / 2</span>
      </div>
    </template>

    <template #audience>
      <span class="fb-phone-q"></span>
      <div class="fb-phone-context">
        The capital of <span class="fb-phone-blank-spot"></span> is Lisbon.
      </div>
      <div class="fb-phone-input">
        <span class="fb-phone-typed">Portuga<span class="fb-caret">|</span></span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewFillBlanks',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
})
</script>

<style scoped lang="scss">
.fb-bar {
  display: block; height: 7px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.18);
}
.fb-bar--md { width: 50%; }

.fb-question {
  padding-bottom: 6px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.fb-sentence {
  display: flex; flex-wrap: wrap; gap: 6px;
  font-size: 16px; font-weight: 700;
  color: rgba(15, 15, 20, 0.85);
  align-items: center;
  flex: 1;
  padding: 10px 0;
  line-height: 1.6;
}
.fb-word { white-space: nowrap; }
.fb-blank {
  position: relative;
  display: inline-block;
  border-bottom: 2.5px solid rgba(15, 15, 20, 0.25);
  min-width: 70px;
  padding: 0 6px 2px;
  text-align: center;
}
.fb-blank-text {
  display: inline-block;
  color: rgba(15, 15, 20, 0.85);
}
.fb-blank.--active {
  border-bottom-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 10%, white);
  border-radius: 4px 4px 0 0;
  animation: fb-highlight 4s ease-in-out infinite;
}
.fb-blank.--active .fb-blank-text {
  color: var(--accent);
  opacity: 0;
  animation: fb-typein 4s ease-out infinite;
}

.fb-meta {
  display: flex; align-items: center; gap: 6px;
}
.fb-dot {
  width: 8px; height: 8px;
  border-radius: 999px;
  background: var(--accent);
  animation: fb-pulse 4s ease-in-out infinite;
}
.fb-meta-label {
  font-size: 10px; font-weight: 700;
  color: var(--accent);
}

/* ---- Audience phone ---- */
.fb-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.fb-phone-context {
  font-size: 12px; font-weight: 600;
  color: rgba(15, 15, 20, 0.85);
  line-height: 1.5;
}
.fb-phone-blank-spot {
  display: inline-block;
  width: 50px; height: 12px;
  border-bottom: 2px solid var(--accent);
  vertical-align: middle;
  margin: 0 2px;
}
.fb-phone-input {
  border: 1px solid color-mix(in srgb, var(--accent) 50%, transparent);
  border-radius: 8px;
  padding: 10px;
  background: white;
}
.fb-phone-typed {
  font-size: 13px; font-weight: 700;
  color: rgba(15, 15, 20, 0.85);
}
.fb-caret {
  color: var(--accent);
  animation: fb-blink 1s steps(2) infinite;
}

@keyframes fb-typein {
  0%, 14% { opacity: 0; transform: translateY(2px); }
  45%     { opacity: 1; transform: translateY(0); }
  92%, 100% { opacity: 1; }
}
@keyframes fb-highlight {
  0%, 14% { background: white; }
  40%     { background: color-mix(in srgb, var(--accent) 10%, white); }
  92%, 100% { background: color-mix(in srgb, var(--accent) 10%, white); }
}
@keyframes fb-pulse {
  0%, 100% { transform: scale(1); }
  50%      { transform: scale(1.4); }
}
@keyframes fb-blink {
  0%   { opacity: 1; }
  100% { opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .fb-blank.--active, .fb-blank.--active .fb-blank-text, .fb-dot, .fb-caret { animation: none; opacity: 1; }
}
</style>
